import React, { useState } from 'react';
import LiquidGlassCard from '../../components/LiquidGlassCard/LiquidGlassCard';
import Button from '../../components/Button/Button';
import './FAQ.css';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqSections = [
    {
      title: 'General Questions',
      id: 'general',
      questions: [
        {
          q: 'What is OpenSMS?',
          a: 'OpenSMS provides temporary, private phone numbers for SMS verification, allowing you to sign up for online services without exposing your personal phone number. This protects your privacy and helps prevent spam.'
        },
        {
          q: 'How does it work?',
          a: 'Simply choose a number from our available list, use it to receive an SMS verification code for the service you\'re signing up for, and view the received message directly on our platform. The numbers are temporary and are disposed of after a set period.'
        }
      ]
    },
    {
      title: 'Privacy & Security',
      id: 'privacy',
      questions: [
        {
          q: 'Is my data safe?',
          a: 'Absolutely. We prioritize your privacy. We do not log your IP address or require any personal information to use our service. All message data is automatically deleted from our servers after a short period.'
        },
        {
          q: 'Are the phone numbers private?',
          a: 'Yes, unlike many free services, our numbers are private and dedicated to you for their lifespan. They are not shared with other users simultaneously, which prevents account hijacking and ensures you receive your verification code reliably.'
        }
      ]
    }
  ];

  const toggleQuestion = (sectionIndex, questionIndex) => {
    const key = `${sectionIndex}-${questionIndex}`;
    setOpenIndex(openIndex === key ? null : key);
  };

  return (
    <div className="faq-page">
      <div className="container">
        <div className="faq-header">
          <h1 className="page-title">Help & Support</h1>
          <p className="page-subtitle">Find answers to common questions below. Can't find what you need? We're here to help.</p>
        </div>

        <div className="faq-content">
          <div className="faq-search">
            <div className="search-wrapper">
              <span className="material-symbols-outlined search-icon">search</span>
              <input
                type="text"
                className="search-input"
                placeholder="Search for answers..."
              />
            </div>
          </div>

          <div className="faq-sections">
            {faqSections.map((section, sectionIndex) => (
              <section key={section.id} className="faq-section">
                <h2 className="faq-section-title">{section.title}</h2>
                <LiquidGlassCard>
                  <div className="faq-list">
                    {section.questions.map((item, questionIndex) => {
                      const isOpen = openIndex === `${sectionIndex}-${questionIndex}`;
                      return (
                        <div key={questionIndex} className={`faq-item ${questionIndex !== section.questions.length - 1 ? 'faq-item-border' : ''}`}>
                          <button
                            className="faq-question"
                            onClick={() => toggleQuestion(sectionIndex, questionIndex)}
                          >
                            <span>{item.q}</span>
                            <span className={`material-symbols-outlined faq-icon ${isOpen ? 'faq-icon-open' : ''}`}>
                              expand_more
                            </span>
                          </button>
                          {isOpen && (
                            <div className="faq-answer">
                              {item.a}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </LiquidGlassCard>
              </section>
            ))}
          </div>

          <LiquidGlassCard className="contact-section">
            <div className="contact-header">
              <h2 className="contact-title">Still Have Questions?</h2>
              <p className="contact-subtitle">Our support team is ready to assist you. Reach out and we'll get back to you as soon as possible.</p>
              <p className="contact-email">
                <a href="mailto:support@opensms.com">support@opensms.com</a>
              </p>
            </div>
            <form className="contact-form">
              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Name</label>
                  <input type="text" className="form-input" />
                </div>
                <div className="form-group">
                  <label className="form-label">Email</label>
                  <input type="email" className="form-input" />
                </div>
              </div>
              <div className="form-group">
                <label className="form-label">Subject</label>
                <input type="text" className="form-input" />
              </div>
              <div className="form-group">
                <label className="form-label">Message</label>
                <textarea className="form-textarea" rows="4"></textarea>
              </div>
              <Button type="submit" variant="primary" fullWidth>Send Message</Button>
            </form>
          </LiquidGlassCard>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
